export default __webpack_public_path__ + "static/media/DANTE.d80edd18.png";